export var permissionActions = {
    EDIT: 'EDIT',
    EXPORT: 'EXPORT',
    IMPORT: 'IMPORT',
    EXTEND: 'EXTEND',
    DELETE: 'DELETE',
    ADD: 'ADD',
    STOP: 'STOP',
    NOTEDITVISBILITY: 'NOTEDITVISBILITY',
    EDIT_NONE: 'EDIT_NONE',
    EDIT_ALL: 'EDIT_ALL',
    EDIT_SELF: 'EDIT_SELF',
};
export var PermissionMap = {
    EDIT: i18n.get('允许编辑'),
    EXPORT: i18n.get('允许导出'),
    IMPORT: i18n.get('允许导入'),
    EXTEND: i18n.get('允许扩展'),
    DELETE: i18n.get('允许删除'),
    ADD: i18n.get('允许添加'),
    STOP: i18n.get('允许停启用'),
    NOTEDITVISBILITY: i18n.get('不可修改可见范围'),
    EDIT_NONE: i18n.get('不允许编辑'),
    EDIT_ALL: i18n.get('允许编辑全量数据(包含数据中心下发）'),
    EDIT_SELF: i18n.get('允许编辑子企业自建数据'),
};
export function getPermissionOptions(optionValues, isRadio, model) {
    var label = isRadio ? 'name' : 'label';
    var options = (optionValues === null || optionValues === void 0 ? void 0 : optionValues.map(function (item) {
        var _a;
        var key = item;
        if (model === 'FORM' && item === permissionActions['EDIT'])
            key = permissionActions['EDIT_ALL'];
        return _a = {}, _a[label] = PermissionMap[key], _a.value = item, _a;
    })) || [];
    return options;
}
